import api from '../api';

/**
 * Upload un certificat obligatoire pour une intervention
 */
export const uploadCertificat = (interventionId, data) =>
  api.dropbox
    .custom('certificat')
    .custom(interventionId)
    .post(data);

export default {
  uploadCertificat,
};
